(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["red-week-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.rw-countdown');
    sections.forEach(function (section) {
      var target = section.getAttribute('data-target');
      if (!target) return;
      var finishedText = section.getAttribute('data-finished-text') || '';
      var dayEl = section.querySelector('[data-rw-days]');
      var hourEl = section.querySelector('[data-rw-hours]');
      var minEl = section.querySelector('[data-rw-minutes]');
      var secEl = section.querySelector('[data-rw-seconds]');
      var headingEl = section.querySelector('.rw-countdown__heading');

      var targetTime = new Date(target).getTime();
      if (isNaN(targetTime)) {
        if (dayEl) dayEl.textContent = '--';
        return;
      }

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        var diff = targetTime - Date.now();
        if (diff <= 0) {
          section.classList.add('is-finished');
          if (finishedText && headingEl) headingEl.textContent = finishedText;
          if (dayEl) dayEl.textContent = '00';
          if (hourEl) hourEl.textContent = '00';
          if (minEl) minEl.textContent = '00';
          if (secEl) secEl.textContent = '00';
          clearInterval(handle);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (dayEl) dayEl.textContent = pad(d);
        if (hourEl) hourEl.textContent = pad(h);
        if (minEl) minEl.textContent = pad(m);
        if (secEl) secEl.textContent = pad(s);
      }

      tick();
      var handle = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["red-week-hero-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KL_REVISION = '2026-04-15';
    var KL_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
    var ITI_VERSION = '24';
    var ITI_CSS = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + ITI_VERSION + '/build/css/intlTelInput.css';
    var ITI_JS  = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + ITI_VERSION + '/build/js/intlTelInputWithUtils.min.js';

    function loadITI(callback) {
      if (window.intlTelInput) { callback(); return; }
      if (!document.querySelector('link[data-rw-iti-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = ITI_CSS;
        link.setAttribute('data-rw-iti-css', '1');
        document.head.appendChild(link);
      }
      var existing = document.querySelector('script[data-rw-iti-js]');
      if (existing) {
        existing.addEventListener('load', callback);
        return;
      }
      var script = document.createElement('script');
      script.src = ITI_JS;
      script.setAttribute('data-rw-iti-js', '1');
      script.onload = callback;
      document.head.appendChild(script);
    }

    function initPhone(form) {
      var phoneEl = form.querySelector('input[name="phone"]');
      if (!phoneEl || phoneEl.dataset.itiBound) return;
      phoneEl.dataset.itiBound = '1';
      try {
        form._iti = window.intlTelInput(phoneEl, {
          initialCountry: 'fr',
          preferredCountries: ['fr', 'be', 'ch', 'lu', 'gb', 'us', 'ca', 'es', 'it', 'de', 'pt'],
          separateDialCode: true,
          formatOnDisplay: true,
          autoPlaceholder: 'aggressive'
        });
      } catch (_) {}
    }

    function bindForm(form) {
      if (form.dataset.rwBound) return;
      form.dataset.rwBound = '1';

      var publicKey = form.dataset.publicKey;
      var listId = form.dataset.listId;
      var source = form.dataset.source || 'Red Week Waitlist';
      var successMsg = form.dataset.success || 'Inscription confirmée.';
      var errorMsg = form.dataset.error || "Une erreur s'est produite. Réessaye dans un instant.";
      var feedback = form.querySelector('[data-rw-feedback]');
      var consentRequired = (form.dataset.consentRequired || 'true') !== 'false';

      if (!publicKey || !listId) {
        if (feedback) {
          feedback.classList.add('is-error');
          feedback.textContent = 'Configuration Klaviyo manquante.';
        }
        return;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (feedback) { feedback.textContent = ''; feedback.className = 'rw-hf__feedback'; }

        var emailEl = form.querySelector('input[name="email"]');
        var phoneEl = form.querySelector('input[name="phone"]');
        var consentEl = form.querySelector('input[name="consent"]');

        var email = emailEl ? emailEl.value.trim() : '';
        var phoneRaw = phoneEl ? phoneEl.value.trim() : '';
        var phone = '';
        if (phoneRaw) {
          if (form._iti && typeof form._iti.getNumber === 'function') {
            if (typeof form._iti.isValidNumber === 'function' && !form._iti.isValidNumber()) {
              if (feedback) { feedback.classList.add('is-error'); feedback.textContent = 'Numéro de téléphone invalide.'; }
              return;
            }
            phone = form._iti.getNumber() || '';
          } else {
            phone = phoneRaw.charAt(0) === '+' ? phoneRaw : '+' + phoneRaw.replace(/[^0-9]/g, '');
          }
        }
        var consentChecked = consentEl ? consentEl.checked : true;

        if (!email) {
          if (feedback) { feedback.classList.add('is-error'); feedback.textContent = 'Email requis.'; }
          return;
        }
        if (consentRequired && !consentChecked) {
          if (feedback) { feedback.classList.add('is-error'); feedback.textContent = 'Merci de cocher la case de consentement.'; }
          return;
        }

        var nowIso = new Date().toISOString();
        var profileAttrs = {
          email: email,
          subscriptions: {
            email: { marketing: { consent: 'SUBSCRIBED', consented_at: nowIso } }
          }
        };
        if (phone) {
          profileAttrs.phone_number = phone;
          profileAttrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED', consented_at: nowIso } };
        }

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttrs
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        };

        form.classList.add('is-submitting');

        fetch(KL_ENDPOINT + encodeURIComponent(publicKey), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': KL_REVISION
          },
          body: JSON.stringify(payload)
        })
        .then(function (res) {
          form.classList.remove('is-submitting');
          if (res.status === 202 || res.status === 200) {
            if (feedback) {
              feedback.classList.add('is-success');
              feedback.textContent = successMsg;
            }
            form.reset();
            if (consentEl) consentEl.checked = true;
            try { window.dispatchEvent(new CustomEvent('rw:subscribed', { detail: { email: email } })); } catch (_) {}
          } else {
            return res.json().then(function (body) {
              var msg = errorMsg;
              if (body && body.errors && body.errors[0] && body.errors[0].detail) {
                msg = body.errors[0].detail;
              }
              if (feedback) { feedback.classList.add('is-error'); feedback.textContent = msg; }
            }).catch(function () {
              if (feedback) { feedback.classList.add('is-error'); feedback.textContent = errorMsg; }
            });
          }
        })
        .catch(function () {
          form.classList.remove('is-submitting');
          if (feedback) { feedback.classList.add('is-error'); feedback.textContent = errorMsg; }
        });
      });
    }

    document.querySelectorAll('form[data-rw-klaviyo]').forEach(function (form) {
      bindForm(form);
      loadITI(function () { initPhone(form); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
